import { inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { CenterApiService } from '@shared/services';
import { FormConfig } from '../edit-create-form.interfaces';
import { CENTER_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const roomFormConfig = (): FormConfig => {
  const centerApiService = inject(CenterApiService);

  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'code', label: 'Mã phòng', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập mã phòng',
        disabled: (editMode) => editMode
      },
      {
        key: 'name', label: 'Tên phòng', required: true, width: 'half',
        type: 'text', placeholder: 'Nhập tên phòng'
      },
      {
        key: 'centerId', label: 'Trung tâm', required: true, width: 'full',
        type: 'select', config: { ...CENTER_SELECT_CONFIG, service: centerApiService },
        placeholder: 'Chọn trung tâm'
      },
      {
        key: 'bestCap', label: 'Best cap', width: 'half',
        type: 'text', validators: [Validators.min(1)], placeholder: 'Nhập sức chứa tối ưu'
      },
      {
        key: 'maxCap', label: 'Max cap', width: 'half',
        type: 'text', validators: [Validators.min(1)], placeholder: 'Nhập sức chứa tối đa'
      }
    ]
  };
};
